import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const Dashboard = ({ user }) => {
  return (
    <Container>
      <h1>Welcome back, {user?.name}!</h1>
      <p>Manage your content, view analytics, and access premium features.</p>
    </Container>
  );
};

export default Dashboard;
